export enum GroupingConferenceDivision {
  Overall = "OVERALL",
  Division = "DIVISION",
  Conference = "CONFERENCE",
}
